module.exports = require('./helpers/bundle-url').getBundleURL('hHmmC') + require('./helpers/bundle-manifest').resolve("aID0a");